import { render, staticRenderFns } from "./BudgetSelector.vue?vue&type=template&id=420d5e81&scoped=true"
import script from "./BudgetSelector.vue?vue&type=script&lang=js"
export * from "./BudgetSelector.vue?vue&type=script&lang=js"
import style0 from "./BudgetSelector.vue?vue&type=style&index=0&id=420d5e81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420d5e81",
  null
  
)

export default component.exports